import React from 'react'
import {useSelector} from 'react-redux';
import PlayButton from './playbutton';

const Gameover = () => {
    const score = useSelector(state => state.points);
    return (
        <div id="game-over">
            <i className="fas fa-hourglass-end fa-2x"></i>
            <span className="primary"> Game Over :(</span>
            <div className="result">
                <img src="https://thumbs.gfycat.com/FoolhardyInsecureFinnishspitz-size_restricted.gif" alt="car"></img>
                <div className="score">
                    <h1 className="secondary">The Car has been collided with the obstacle. Well played! Try your best to get high scores...</h1>
                    <div>
                        <h1 className="primary">
                            <i className="fas fa-trophy"></i>&nbsp;&nbsp;Your Score&nbsp;&nbsp;
                            <i className="fas fa-trophy"></i>
                        </h1>
                        <h1 className="primary">
                            <i className="fas fa-crown"></i>&nbsp;
                            <span>{typeof(score)!==typeof(new Date())?score:0}</span>
                            &nbsp; 
                            <i className="fas fa-crown"></i>
                        </h1>
                    </div>
                </div>
                <PlayButton/>
            </div>
        </div>
    )
}

export default Gameover
